import { Entity } from '../base/entity';
import { Partner } from '../lookups/partner';

export class Nabavka extends Entity {

  public static readonly TABLENAME = 'nabavka';

  public static readonly ID = 'id';
  public static readonly PREDMET_ID = 'predmet_id';
  public static readonly PLAN_EXTERNAL_ID = 'plan_external_id';
  public static readonly GODINA = 'godina';
  public static readonly BROJ_NABAVKE = 'broj_nabavke';
  public static readonly OPIS = 'opis';
  public static readonly PARENT_ID = 'parent_id';
  public static readonly STATUS = 'status';
  public static readonly TIP_NABAVKE = 'tip_nabavke';
  public static readonly COMPANY_ID = 'company_id';
  public static readonly VRSTA_POSTUPKA_ID = 'vrsta_postupka_id';
  public static readonly OBAVEZANZJ = 'obavezanZJ';
  public static readonly VRDESNOST_BEZ_PDV = 'vrdesnostBezPdv';
  public static readonly VRDESNOST_SA_PDV = 'vrdesnostSaPdv';
  public static readonly POKRETANJE_POSTUPKA = 'pokretanje_postupka';
  public static readonly ZAKLJUCENJA_UGOVORA = 'zakljucenjaUgovora';
  public static readonly IZVRSENJA_UGOVORA = 'izvrsenjaUgovora';

  public static readonly RAZLOG_I_OPRAVDANOST = 'razlogIOpravdanost';
  public static readonly NACIN_UTVRDJIVANJA_PROCENJENE_VREDNOSTI = 'nacinUtvrdjivanjaProcenjeneVrednosti';
  public static readonly OSTALE_NAPOMENE = 'ostaleNapomene';
  public static readonly TIP = 'tip';
  public static readonly KOEFICIJENT = 'koeficijent';
  public static readonly PARTNER_ID = 'partner_id';
  public static readonly IZVODJAC_RADOVA = 'izvodjac_radova';
  public static readonly NADZORNI_ORGAN = 'nadzorni_organ';
  public static readonly OBJEKAT = 'objekat';
  public static readonly LOKACIJA = 'lokacija';
  public static readonly GLAVNI_PROJEKTANT_ID = 'glavni_projektant_id';
  public static readonly PRIVREMENI_MAGACIN_ID = 'privremeni_magacin_id';


  id: string;
  predmetId: number;
  planExternalId: number;
  godina: number;
  brojNabavke: string;
  opis: string;
  parentId: string;
  status: number;
  tipNabavke: number;
  companyId: string;
  vrstaPostupkaId: number;
  obavezanzj: boolean;
  vrdesnostBezPdv: number;
  vrdesnostSaPdv: number;
  pokretanjePostupka: Date;
  zakljucenjaUgovora: Date;
  izvrsenjaUgovora: Date;
  partnerId: string;

  razlogIOpravdanost: string;
  nacinUtvrdjivanjaProcenjeneVrednosti: string;
  ostaleNapomene: string;
  tip: number;
  izvodjacRadoa: string;
  nadzorniOrgan: string;
  objekat: string;
  lokacija: string;
  glavniProjektantId: number;
  privremeniMagacinId: string;
  koeficijent: number;
  partner: string;
}
